<template>
  <div class="authForm">
    <div>
      <b-tabs class="authForm__wrapper" no-key-nav>
        <div class="authForm__label">
          <img v-if="customLogo" :src="customLogo" alt="Tangle" class="authForm__customLogo" height="50">
          <img src="@/assets/imgs/logo.png" alt="Tangle">
          <img
            v-if="authInProgress"
            src="@/assets/imgs/gifs/loading.gif"
            class="authForm__inProgress"
            alt="loading"
          >
        </div>
        <b-tab title="Reset Password">
          <b-form @submit.prevent="submitSignIn" novalidate>
            <b-form-group label="E-mail:" label-for="signInEmailInput">
              <b-form-input
                id="signInEmailInput"
                type="email"
                required
                placeholder="example@domain.com"
                autocomplete="on"
                v-model.trim="$v.email.$model"
                :class="{ 'is-invalid': $v.email.$error }"
                disabled
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Enter New Password:" label-for="passwordInput">
              <b-form-input
                id="passwordInput"
                type="text"
                required
                autocomplete="on"
                v-model.trim="$v.password.$model"
                :class="{ 'is-invalid': $v.password.$error }"
                :disabled="authInProgress"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!$v.password.required">Password field is required</b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-if="!$v.password.minLength && $v.password.required"
              >Password must have at least {{$v.password.$params.minLength.min}} letters</b-form-invalid-feedback>
            </b-form-group>
            <div>
              <b-button
                variant="info"
                class="authForm__submit"
                type="submit"
                :disabled="authInProgress"
              >Reset Pass</b-button>
            </div>
          </b-form>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
// modules
import { mapState } from "vuex";
import { required, minLength, email } from "vuelidate/lib/validators";
// services
import axios from "axios";
import auth from "@/services/auth";
import { setTimeout } from "timers";
import config from '@/config'

export default {
  data() {
    return {
      email: "",
      password: "",
      resetPassRes: {},
      customLogo: localStorage.getItem("logo")
    };
  },
  computed: {
    ...mapState(["authInProgress"])
  },
  methods: {
    async submitSignIn() {
      const functionsUrl = config.midServer[process.env.APP_CONF.instance]
      const functionLink = `${functionsUrl}/resetPasswordByEmail`;
      if (this.authInProgress) return;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      await axios
        .post(
          functionLink,
          JSON.stringify({ newPassword: this.password, email: encodeURIComponent(this.email) })
        )
        .then(res => {})
        .catch(err => console.log("errr"));

      //Singing out with old password
      await auth.signOut(this.isUserAnonymous, this.userId, err => {
        this.$store.commit("markUserAsAnonymous", false);
        this.$store.commit("destroyCasl");

        if (err) {
          this.$store.commit("addError", err.message);
        }
      });
      //Signing in with new password
      this.$store.commit("addProcess", {
        process: "signIn",
        message: "Sign in"
      });
      this.$store.commit("destroyCasl");
      auth.signIn(this.email, this.password, err => {
        this.$store.commit("deleteProcess", "signIn");
        if (err) this.$store.commit("addError", err.message);

        const lastDash = localStorage.getItem("lastDash");
        if (lastDash) this.$router.push(`/dashboard/${lastDash}`);
      });
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    }
  },
  mounted() {
    this.email = auth.getCurrentUserEmail();
  }
};
</script>
<style lang="scss">
@import "~$scss/globals";

.authForm {
  height: 100vh;
  overflow: auto;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  &__wrapper {
    width: 300px;
  }
  &__label {
    position: relative;
    text-align: center;
    padding: {
      top: 15px;
      bottom: 10px;
    }
    border-bottom: 1px solid $borderColor2;
    margin-bottom: 10px;
  }
  &__inProgress {
    position: absolute;
    right: -3px;
    top: 76px;
    width: 35px;
    height: 35px;
  }
  .tab-content {
    border: 1px solid $borderColor1;
    border-top: 0;
    margin-top: -1px;
    padding: 0 15px 15px 15px;
  }
  &__submit {
    width: 100%;
  }
  &__anonymous {
    padding-top: 10px;
    .btn {
      width: 100%;
    }
  }
}
</style>
